import { render, staticRenderFns } from "./WizardChooseName.vue?vue&type=template&id=7c76ede2&scoped=true&"
import script from "./WizardChooseName.vue?vue&type=script&lang=js&"
export * from "./WizardChooseName.vue?vue&type=script&lang=js&"
import style0 from "./WizardChooseName.vue?vue&type=style&index=0&id=7c76ede2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c76ede2",
  null
  
)

export default component.exports